// extracted by mini-css-extract-plugin
export default {"textContainer":"UserTab_textContainer__fU0eS","text":"UserTab_text__lLCyR"};